export const VEHICLE_EXPORT_ID = 'vechicle';

export const VEHICLE_TITLE = 'Vehículos';

export const LOCALIZED_PROPERTIES = {
  code: 'Código',
  externalKeys: 'Código Externo',
  name: 'Nombre',
  brand: 'Marca',
  plate: 'Placa',
  type: 'Tipo',
  description: 'Descripción',
  company: 'Compañía',
  businessPartner: 'Socio de negocio',
  ownership:'Propiedad',
  height: 'Altura',
  width: 'Ancho',
  length: 'Largo',
  dimensionUnitOfMeasure: 'Ud. Medida',
  grossWeight: 'Peso bruto',
  netWeight: 'Peso neto',
  weightUnitOfMeasure: 'Ud. Medida',
  volume: 'Volumen',
  volumeUnitOfMeasure: 'Ud. Medida'
};
